import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";

const postJsonRequest = (apiUrl, payload, tokenInfo) =>
  fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${tokenInfo.id_token}`,
      Principal: tokenInfo.access_token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

export const getCJWDICostFileStatus = async (fileId) => {
  if (!fileId) {
    throw new Error("Missing CJW-DI file ID.");
  }

  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const statusPath = localDatabaseUrls.serviceURL.cjwDiCostFileStatus
    .replace("{fileId}", encodeURIComponent(fileId));
  const response = await getAPI(
    `${localDatabaseUrls.baseURL}${statusPath}`,
    tokenInfo
  );

  if (response?.status === 200 || response?.ok) {
    return response.json();
  }

  const errorData = await response?.json?.().catch(() => ({}));
  throw new Error(
    errorData?.message ||
      response?.statusText ||
      "Failed to load CJW-DI cost-file status."
  );
};

export const getCJWDICostFileStatuses = async (fileIds = []) => {
  if (!Array.isArray(fileIds) || fileIds.length === 0) {
    return {};
  }

  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return {};
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiCostFileStatusBatch}`;
  const response = await postJsonRequest(apiUrl, fileIds, tokenInfo);

  if (response?.status === 200 || response?.ok) {
    return response.json();
  }

  const errorData = await response?.json?.().catch(() => ({}));
  const error = new Error(
    errorData?.message ||
      response?.statusText ||
      "Failed to load CJW-DI cost-file statuses."
  );
  error.status = response?.status;
  throw error;
};

export const getCJWDICostFileStatusesByBatch = async (batchIds = []) => {
  if (!Array.isArray(batchIds) || batchIds.length === 0) {
    return {};
  }

  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return {};
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiCostFileStatusByBatch}`;
  const response = await postJsonRequest(apiUrl, batchIds, tokenInfo);

  if (response?.status === 200 || response?.ok) {
    return response.json();
  }

  const errorData = await response?.json?.().catch(() => ({}));
  const error = new Error(
    errorData?.message ||
      response?.statusText ||
      "Failed to load CJW-DI cost-file statuses by batch."
  );
  error.status = response?.status;
  throw error;
};

export default getCJWDICostFileStatus;
